module.exports = __webpack_public_path__ + "05_short_brown.91aabbf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/05_short_brown.png
// module id = twHN
// module chunks = 0